import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { PRODUCTS } from "../catalog";
import { familyOf, MAX_COMPARE, FAMILY_LABELS } from "../compare";

const CompareCtx = createContext(null);
const KEY = "hgw-compare";

export function CompareProvider({ children }) {
  const [slugs, setSlugs] = useState(() => {
    try {
      return (JSON.parse(localStorage.getItem(KEY)) || []).filter((s) => PRODUCTS[s]);
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(slugs));
  }, [slugs]);

  const toggle = useCallback((slug, lang = "it") => {
    setSlugs((cur) => {
      if (cur.includes(slug)) return cur.filter((s) => s !== slug);
      const fam = familyOf(PRODUCTS[slug]);
      const curFam = cur.length ? familyOf(PRODUCTS[cur[0]]) : fam;
      if (fam !== curFam) {
        toast(lang === "it"
          ? `Confronto riavviato: puoi confrontare solo sistemi della stessa famiglia (${FAMILY_LABELS[fam][lang]}).`
          : `Comparison restarted: you can only compare systems of the same family (${FAMILY_LABELS[fam][lang]}).`);
        return [slug];
      }
      if (cur.length >= MAX_COMPARE) {
        toast(lang === "it" ? `Puoi confrontare al massimo ${MAX_COMPARE} sistemi.` : `You can compare up to ${MAX_COMPARE} systems.`);
        return cur;
      }
      return [...cur, slug];
    });
  }, []);

  const remove = useCallback((slug) => setSlugs((cur) => cur.filter((s) => s !== slug)), []);
  const clear = useCallback(() => setSlugs([]), []);

  return <CompareCtx.Provider value={{ slugs, toggle, remove, clear }}>{children}</CompareCtx.Provider>;
}

export const useCompare = () => useContext(CompareCtx);
